import { isDesktopPlatform } from '@/lib/desktop/bridge';

/**
 * Whether the current shell forbids a plaintext TanStack Query cache in
 * `localStorage`.
 *
 * True for the desktop renderer. Its `localStorage` is not stored in a browser
 * profile the user can inspect or clear. The cache is a default-allow denylist
 * held for a 24h `maxAge`, so anything a new query root forgets to exclude lands
 * there by default — the wrong default for constituent data. The desktop shell
 * keeps a long-lived renderer, so the cache buys it nothing a refetch does not.
 *
 * Kept out of `query-persistence.ts` so that module imports nothing but query-key
 * roots, and never reaches for platform detection or the desktop bridge. What it
 * exports is a pure predicate over a query key, testable without stubbing a
 * platform; that property is worth one extra file.
 */
export function isPlaintextCacheDisallowed(): boolean {
  return isDesktopPlatform();
}
